const GetGameName = [
    'Squirrlo', 'Jupitario', 'Deepmarine', 'SpaceX', 'Freesign', 'KanwaKango', 'Lexileague',
     'Trainaid', 'Loopylizer', 'DinerDash', 'SugarSmash', 'StreetSprint', 'CanalTour', 'AntBattle', 'HexMatch', 'BeastBasket' ,'ActBig',
     'SolarizCity', 'BehiveLab', 'RubiFruit', 'SpaceBumper', 'GridTwist', 'PaintSplash'
  ];

  export default GetGameName;